module.exports = __webpack_public_path__ + "img/user.21d4dc9d.svg";